import {
    AdLoadingStrategyTypeEnum,
    AdSizes,
    AdUnit,
    AdUnitSpecialUseCaseEnum,
    AdUnitTypeEnum,
    PageAdsBuilder
} from "@repo/lib-domain-tag";
import { pageBidderHelper } from "../pageBidderHelper";
import { deviceUtil, pageUtil } from "@repo/lib-common";
import { desktopOutOfPageAdUnit } from "../../commonAdUnits/outOfPageAdUnits";
import {fixPageSkinCssClass} from "../utilHelpers.ts";


export class DesktopFinanceForexPageAdsBuilder extends PageAdsBuilder {
    override init() {

        this.setIsAutoRefreshEnabled(true);
        this.applyAdUnit(
            AdUnit.builder(AdUnitTypeEnum.banner)
                .setDeviceType(deviceUtil.DeviceTypeInfo.desktopDevices)
                .setSpecialUseCase(AdUnitSpecialUseCaseEnum.none)
                .setIsEnabled(true)
                .setAdUnitPath("/66738120/sozcu_gen_pageskin_tepe")
                .setDivId("div-sozcu_gen_pageskin_tepe")
                .setDivStyleAfterRequest('')
                .setLoadingStrategy(AdLoadingStrategyTypeEnum.sra)
                .setSizes(AdSizes.desktop_PageSkin_Top)
                .setIsAutoRefreshEnabled(true)
                .setIsPrebidEnabled(false)

            //.setPrebidSizeLimits([])
            //.setBidderHelper(pageBidderHelper)
            .onSlotRenderEnded(fixPageSkinCssClass)


        );
        this.applyAdUnit(
            AdUnit.builder(AdUnitTypeEnum.banner)
                .setDeviceType(deviceUtil.DeviceTypeInfo.desktopDevices)
                .setSpecialUseCase(AdUnitSpecialUseCaseEnum.none)
                .setIsEnabled(true)
                .setAdUnitPath("/66738120/sozcu_gen_masthead")
                .setDivId("div-sozcu_gen_masthead")
                .setDivStyleAfterRequest('')
                .setLoadingStrategy(AdLoadingStrategyTypeEnum.sra)
                .setSizes(AdSizes.desktop_Masthead)
                .setIsAutoRefreshEnabled(true)
                .setIsPrebidEnabled(true)
                .setPrebidSizeLimits(AdSizes.prebid_970x250)
                .setBidderHelper(pageBidderHelper)
                .setBidderCustomParam('taboola', { tagId: 'sozcu_gen_masthead' })
            //.onSlotRenderEnded(fixPageSkinCssClass)

        );

        this.applyAdUnit(
            AdUnit.builder(AdUnitTypeEnum.banner)
                .setDeviceType(deviceUtil.DeviceTypeInfo.desktopDevices)
                .setSpecialUseCase(AdUnitSpecialUseCaseEnum.none)
                .setIsEnabled(true)
                .setAdUnitPath("/66738120/sozcu_gen_left")
                .setDivId("div-sozcu_gen_left")
                .setDivStyleAfterRequest('')
                .setLoadingStrategy(AdLoadingStrategyTypeEnum.sra)
                .setSizes(AdSizes.desktop_Tower)
                .addSizeMapping([1900, 0], [[300, 600], [160, 600], [120, 600], [1, 1]])
                .addSizeMapping([1366, 0], [[160, 600], [120, 600], [1, 1]])
                .addSizeMapping([0, 0], [])
                .setIsAutoRefreshEnabled(true)
                .setIsPrebidEnabled(true)
                .setPrebidSizeLimits(AdSizes.prebid_300x600)
                .setBidderHelper(pageBidderHelper)
                .setBidderCustomParam('taboola', { tagId: 'sozcu_gen_left' })
            //.onSlotRenderEnded(fixPageSkinCssClass)

        );

        this.applyAdUnit(
            AdUnit.builder(AdUnitTypeEnum.banner)
                .setDeviceType(deviceUtil.DeviceTypeInfo.desktopDevices)
                .setSpecialUseCase(AdUnitSpecialUseCaseEnum.none)
                .setIsEnabled(true)
                .setAdUnitPath("/66738120/sozcu_gen_right")
                .setDivId("div-sozcu_gen_right")
                .addSizeMapping([1900, 0], [[300, 600], [160, 600], [120, 600], [1, 1]])
                .addSizeMapping([1366, 0], [[160, 600], [120, 600], [1, 1]])
                .addSizeMapping([0, 0], [])
                .setDivStyleAfterRequest('')
                .setLoadingStrategy(AdLoadingStrategyTypeEnum.sra)
                .setSizes(AdSizes.desktop_Tower)
                .setIsAutoRefreshEnabled(true)
                .setIsPrebidEnabled(true)
                .setPrebidSizeLimits(AdSizes.prebid_300x600)
                .setBidderHelper(pageBidderHelper)
                .setBidderCustomParam('taboola', { tagId: 'sozcu_gen_right' })
            //.onSlotRenderEnded(fixPageSkinCssClass)

        );

        this.applyAdUnit(
            AdUnit.builder(AdUnitTypeEnum.banner)
                .setDeviceType(deviceUtil.DeviceTypeInfo.desktopDevices)
                .setSpecialUseCase(AdUnitSpecialUseCaseEnum.none)
                .setIsEnabled(true)
                .setAdUnitPath("/66738120/sozcu_gen_body_box_1")
                .setDivId("div-sozcu_gen_body_box_1")
                .setDivStyleAfterRequest('')
                .setLoadingStrategy(AdLoadingStrategyTypeEnum.intersectionObserverBasedLazyLoad)
                .setSizes(AdSizes.desktop_GenBodyBox)
                .setIsAutoRefreshEnabled(true)
                .setIsPrebidEnabled(true)
                .setPrebidSizeLimits(AdSizes.prebid_300x250)
                .setBidderHelper(pageBidderHelper)
                .setBidderCustomParam('taboola', { tagId: 'sozcu_gen_body_box_1' })

        );

        this.applyAdUnit(
            AdUnit.builder(AdUnitTypeEnum.banner)
                .setDeviceType(deviceUtil.DeviceTypeInfo.desktopDevices)
                .setSpecialUseCase(AdUnitSpecialUseCaseEnum.none)
                .setIsEnabled(true)
                .setAdUnitPath("/66738120/sozcu_footer_masthead")
                .setDivId("div-sozcu_footer_masthead")
                .setDivStyleAfterRequest('')
                .setLoadingStrategy(AdLoadingStrategyTypeEnum.intersectionObserverBasedLazyLoad)
                .setSizes(AdSizes.desktop_Masthead)
                .setIsAutoRefreshEnabled(true)
                .setIsPrebidEnabled(true)
                .setPrebidSizeLimits(AdSizes.prebid_970x250)
                .setBidderHelper(pageBidderHelper)
                .setBidderCustomParam('taboola', { tagId: 'sozcu_footer_masthead' })
            //.onSlotRenderEnded(fixPageSkinCssClass)

        );

        desktopOutOfPageAdUnit.forEach(adUnit => {
            this.applyAdUnit(adUnit);
        });




    }
}

export const desktopFinanceForexPageAdsBuilder = new DesktopFinanceForexPageAdsBuilder(deviceUtil.DeviceTypeEnum.desktop, pageUtil.PageTypeEnum.postDetail);


